<template>
  <div class="file-upload_dialog" v-show="showLayer && !homePage && (localFiles.length || cloudFiles.length)">
    <upload-file
      ref="upload"
      :multiple="multiple"
      :drop="drop"
      v-bind="upload"
      :outer-chain="outerChainBaseUrl"
      @input-file="inputFile"
      @change-files="changeFiles"
    ></upload-file>
    <div class="file-upload_head" v-if="localFiles.length || cloudFiles.length">
      <!--<div class="file-upload_head" v-if="spaceFiles.length || dataFiles.length">-->
      <div class="file-upload_head-box" v-if="uploadedLength !== uploadingLength">
        <img class="uploading-img" src="~@/assets/images/upload/scz.gif" width="18px" height="18px"/>
        <span>文件及数据上传中({{uploadedLength}}/{{uploadingLength}})，上传完成前请勿关闭浏览器</span>
      </div>
      <span v-else>
        <i class="w-icon-sucess font-green"></i> 上传完成
      </span>
      <span class="file-upload_option">
        <a :class="[fileContentShow ? 'w-icon-zuixiaohua' : 'w-icon-zuidahua']"
           @click="fileContentShow = !fileContentShow"></a>
        <a class="w-icon-guanbi" v-show="!hasUploadTask" @click="handleUploadClose"></a>
      </span>
    </div>
    <collapse>
      <div class="file-upload_body" id="fileUploadBody" v-show="fileContentShow">
        <w-scrollbar wrap-style="overflow-x: hidden;" style="height: 100%;">
          <div class="file-table_body" :key="changeTaskOrder">
            <!--filesMap渲染-->
            <!--<template v-for="(value, key) in files">-->
            <!--<upload-task-list :key="'taskOrder_' + key"-->
            <!--:name="key"-->
            <!--:fileNameTitle="key"-->
            <!--:files="value.items"-->
            <!--@abort="remove"></upload-task-list>-->
            <!--</template>-->
            <!--filesArray渲染-->
            <template v-for="(file, index) in filesSorted">
              <upload-task-list :key="`task_order_${index}_${file.name}`"
                                :name="file.name"
                                :fileNameTitle="file.name"
                                :files="file.items"
                                @abort="remove"></upload-task-list>
            </template>
          </div>
        </w-scrollbar>
      </div>
    </collapse>
  </div>
</template>

<script>
// import {capitalize, isEmptyObject} from '@/assets/utils'
import _ from 'lodash'
import {getCookie, setCookie} from '@/assets/utils/CommonUtil'
import {isEmptyObject} from '@/assets/utils'
import {zjycloud, backendUrl} from '@/assets/js/config'
import {Collapse} from '@/components/common'
import UploadFile from './UploadFile'
import UploadTaskList from './UploadTaskList'
import Bus from '@/assets/utils/bus'
import service from '@/assets/service'
import axios, {ContentType} from '@/assets/plugins/axios'
import {mapState} from 'vuex'
import {
  closeUploadBoxAlertMessage,
  abortUploadAlertMessage,
  maximumValidateMessage,
  suffixValidateMessage,
  fileSizeValidateMessage,
  capacityValidateMessage,
  duplicateFileAlertMsg,
  inventoryAlertMsg,
  uploadResultUrl,
  name,
  uploadFailMessage
} from './constants'

const importInventory = {
  message: inventoryAlertMsg,
  key: 'ImportType',
  width: 450,
  noCancelBtn: true,
  multipleSubmit: [
    {name: '是', key: 'ImportType', value: 3},
    {name: '否', key: 'ImportType', value: 1}
  ]
}
const importDuplicateFile = {
  message: duplicateFileAlertMsg,
  key: 'optType',
  noCancelBtn: true,
  multipleSubmit: [
    {name: '替换', key: 'optType', value: 1},
    {name: '追加', type: 'minor', key: 'optType', value: 2},
    {name: '跳过', type: 'minor', key: 'optType', value: 3}
  ]
}
const toVip = {
  key: 'ImportType',
  noCancelBtn: true,
  multipleSubmit: [
    {name: '购买套餐', key: 'ImportType', value: 3},
    {name: '确定', key: 'ImportType', value: 1}
  ]
}

export default {
  name: 'Upload',
  components: {
    Collapse,
    UploadFile,
    UploadTaskList
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    drop: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showLayer: false, // 显示窗体
      fileContentShow: true, // 上传任务列表最大化(true)、最小化(false)
      upload: {
        parameter: {token: getCookie('ZJYTOKEN')}, // 参数
        headers: {}, // 请求头
        files: [], //  文件列表
        uploadAction: '', // 上传地址
        directory: false, // 文件夹
        fileSize: 500 * 1024 * 1024, // 单文件大小
        fileSizeValidateMessage,
        maximum: 100, // 批量上传文件数，0不限制
        maximumValidateMessage,
        suffix: '', // 上传限制格式
        suffixValidateMessage,
        capacityValidate: false, // 是否校验空间容量
        capacityValidateMessage, // 校验空间容量提示信息
        nowPage: '', // 当前页
        autoUpload: true
      },
      afterSelectFn: null, // 本地文件选择完成后触发回调
      singleFileNoticeFn: null, // 单文件成功回调
      uploadResultNoticeFn: null, // 上传结果回调
      unmark: [], //  [...projectId] 记录哪些项目有操作过取消动作，后续在当前批次文件上传完成后来综合判断当前批次是否上传成功了【如果有取消操作，备案项目视为上传失败】
      outerChainBaseUrl: '', // 外链上传BaseUrl
      againUpload: false, // 是否是重新上传，重新上传会先走重名校验，去除重名文件后验证空间容量
      uploadResultAction: '', // 接口地址，获取上传结果
      isDrag: false, // 是否拖拽上传
      needRecord: false, // 是否需要上传文件上传记录，对应原因 项目空间 上传操作记录
      isDataModule: false, // 上传数据文件,上传位置(space/data)
      showConfirm: false, // 显示导入清单时一并导入组价确认弹窗，区分是清单还在组价中上传云文件
      callbackParams: {}, // 上传完成回调
      // uploadFilePosition: '', // 上传位置(space/data)
      // taskOrder: ['space', 'data'],
      changeTaskOrder: 0, // 触发空间文件、数据文件显示顺序的更新
      // 临时存储各类文件数据
      moduleName: '', // 归属类型模块名称，如：工程文件、数据文件、图纸文件...等，支持类型自定义
      projectName: '', // 项目名称
      files: {
        // '工程文件': {
        //   updateAt: Date.now(),
        //   uploading: 0,
        //   // items: {
        //   //   '61b80194-b7ac-47ce-b4fb-438688e77a21': {
        //   //     status: 1, // 1上传中、2成功、3失败
        //   //     file: {}
        //   //   },
        //   //   // ...
        //   // },
        //   items: [],
        //   details: {
        //     personage: [],
        //     share: [],
        //     enterprise: []
        //   }
        // }
        // ...
      },
      filesSorted: [],
      localFiles: [], // 本地文件【空间文件&&数据文件】
      cloudFiles: [], // 云文件
      // spaceFiles: [], // 空间文件
      // dataFiles: [], // 数据文件
      uploadingLength: 0, // 正在执行上传任务的文件总数
      uploadedLength: 0, // 上传已经完成的文件总数
      uploadedStatusChangeLength: 0, // 上传完成 和 上传第二种状态 的总数
      uploadingLengthSpace: 0, // 上传中的空间文件数
      uploadingLengthData: 0, // 上传中的数据文件数
      batchFileList: [], // 记录每一批次选择了多少个文件
      batchFilesBox: {}, // 为每个批次创建一个容器，用于记录统计一次用户行为数据
      uploadTask: [] // 临时存储，每次任务列表，用于计算文件是否重复，以便于弹窗提示，事件结束后字段重置为空
    }
  },
  computed: {
    ...mapState({
      uploadTaskShow: state => state.upload.uploadTaskShow
    }),
    // 是否是首页
    homePage () {
      return /\/(index|vip|production|findAdmin)/.test(this.$route.path)
    }
  },
  destroyed () {
    Bus.$off('openUploader')
    Bus.$off('addUploaderFiles')
    Bus.$off('beforeUploadCloudFile')
  },
  mounted () {
    // 上传文件或文件夹
    Bus.$on('openUploader', this.uploadFiles)
    // 拖拽上传
    Bus.$on('addUploaderFiles', this.dragUploadFiles)
    // // 上传云文件
    Bus.$on('beforeUploadCloudFile', this.uploadCloudFile)
    // 上传备案项目
    Bus.$on('uploadProject', this.uploadProject)
    // 重新上传文件
    Bus.$on('againUploadFiles', this.againUploadFiles)
    // 更新文件状态
    Bus.$on('updateFiles', this.updateFiles)
    // 删除文件状态
    Bus.$on('removeFiles', this.removeFiles)
  },
  methods: {
    // 重置默认数据
    setDefaultData (params) {
      try {
        // 调用参数 nowPage parameter={workspaceId, filePath, token} type uploadAction isDataModule showConfirm needRecord suffix suffixAlertMessage
        const {
          parameter = {},
          type,
          isDataModule = false,
          showConfirm = false,
          uploadResultAction = '',
          callbackParams = {},
          suffix = '',
          suffixAlertMessage = suffixValidateMessage,
          fileSize = (500 * 1024 * 1024), // 单文件大小
          maximum = 100,
          maximumAlertMessage = maximumValidateMessage,
          fileSizeAlertMessage = fileSizeValidateMessage,
          capacityAlertMessage = capacityValidateMessage,
          uploadAction,
          nowPage = '',
          moduleName = name,
          isDrag = false,
          needRecord = false,
          againUpload = false,
          projectName = '',
          afterSelectFn = null,
          outerChainBaseUrl = '',
          singleFileNoticeFn = null,
          uploadResultNoticeFn = null,
          headers = {}
        } = params
        // TODO: 参数验证信息校验
        // if ([moduleName, nowPage, isDataModule, needRecord].includes(undefined)) {
        //   this.$message.warning()
        // }
        // 合并参数数据
        let _headers = getCookie('GEIPTOKEN') ? {
          token: getCookie('ZJYTOKEN'),
          geipToken: getCookie('GEIPTOKEN')
        } : {
          token: getCookie('ZJYTOKEN')
        }
        if (Object.prototype.toString.call(headers) === '[object Object]' && !isEmptyObject(headers)) {
          _headers = headers
        }
        Object.assign(this, {
          isDataModule,
          showConfirm,
          uploadResultAction,
          callbackParams,
          isDrag,
          needRecord,
          moduleName,
          afterSelectFn,
          outerChainBaseUrl,
          singleFileNoticeFn,
          uploadResultNoticeFn,
          againUpload,
          projectName,
          upload: {
            // parameter: Object.assign({token: getCookie('ZJYTOKEN')}, parameter),
            parameter,
            suffix,
            suffixValidateMessage: suffixAlertMessage,
            // capacityValidate: false, // 是否校验空间容量
            capacityValidateMessage: capacityAlertMessage, // 校验空间容量提示信息
            maximum,
            maximumValidateMessage: maximumAlertMessage,
            fileSize,
            fileSizeValidateMessage: fileSizeAlertMessage,
            uploadAction: uploadAction ? `${backendUrl}/${uploadAction}` : `${backendUrl}/file/upload`,
            directory: (type === 'folder'),
            nowPage,
            autoUpload: !(typeof afterSelectFn === 'function'),
            headers: _headers
          }
        })
      } catch (e) {
        console.error(e.message)
      }
    },
    // 上传文件或文件夹
    uploadFiles (query = {}, callbackParams = {}) {
      try {
        this.setDefaultData(Object.assign(query, {callbackParams}))
        this.$nextTick(() => {
          this.$refs.upload.selectFile()
        })
      } catch (e) {
        console.error(e.message)
      }
    },
    // 上传备案项目
    uploadProject (query = {}, callbackParams = {}) {
      try {
        this.setDefaultData(Object.assign(query, {callbackParams}))
        this.$nextTick(() => {
          this.$refs.upload.selectFile()
        })
      } catch (e) {
        console.log(this.$refs.upload.selectFile, e)
        console.error(e.message)
      }
    },
    // 拖拽上传
    dragUploadFiles (query = {}) {
      try {
        this.setDefaultData(Object.assign(query, {isDrag: true}))
        this.$nextTick(() => {
          // 调用vue-upload-component中的add方法，把文件手动添加到vue-upload-component组件里
          this.$refs.upload.add(query.files)
        })
      } catch (e) {
        console.error(e.message)
      }
    },
    // 上传云文件
    async uploadCloudFile (list = [], parameter = {}, callbackParams = {}) {
      try {
        const {showConfirm = false, isDataModule = false, moduleName = '', params, nowPage = ''} = parameter
        this.setDefaultData(Object.assign(parameter, {isDataModule: true, callbackParams}))
        list.forEach((item) => {
          Object.assign(item, {
            size: item.length,
            id: item.path,
            progress: 100,
            cloudFile: true,
            nowPage,
            isUploadCloud: true,
            showConfirm,
            callbackParams,
            isDataModule,
            moduleName,
            updateAt: Date.now(),
            locationUrl: window.location.href
          })
        })
        // 确认弹窗：导入清单是否需要把其组价方案一起导入？ --区分是清单还在组价中上传云文件
        if (showConfirm) {
          try {
            const value = await this.importConfirm(importInventory)
            // 确定导入组价方案，合并导入类型参数字段
            Object.assign(parameter.params, {ImportType: value})
          } catch (e) {
            console.error(e.message)
          }
        }
        parameter.params = JSON.stringify(params)
        parameter.locationUrl = window.location.href
        this.cloudFiles.push(...list)
        this.startUploadCloudFile(parameter, callbackParams)
        this.showLayer = true
      } catch (e) {
        console.error(e.message)
      }
    },
    // 重新上传
    async againUploadFiles ({files = [], active = true, projectId, projectName = '', outerChainBaseUrl = '', workspaceId = '', uploadResultNoticeFn = null}) {
      // const replaceFilePath = (typeof projectName === 'string' && projectName.trim())
      const filePathList = []
      files.forEach(file => {
        const filePath = file.name.split('/')
        const newPath = `/${projectName}/${filePath.slice(1).join('/')}`
        file.data.filePath = newPath
        filePathList.push(newPath)
      })
      const sameNameFiles = await this.checkFileExist({
        filePathList,
        sourceWorkspaceId: workspaceId
      })
      let newBatchFileList = []
      if (sameNameFiles.length) {
        files.forEach(fileItem => {
          if (sameNameFiles.includes(fileItem.data.filePath)) {
            this.$refs.upload.remove(fileItem)
          } else {
            newBatchFileList.push(fileItem)
          }
        })
      } else {
        newBatchFileList = [...files]
      }
      if (newBatchFileList.length) {
        let filesSizeTotal = 0
        newBatchFileList.forEach(fileItem => {
          filesSizeTotal += fileItem.size
        })
        this.checkCapacity(filesSizeTotal).then(res => {
          // this.batchFileList.forEach(fileItem => {
          //   fileItem.data.uploadKey = res
          // })
          this.updateFiles({files: newBatchFileList, active: true, projectId, projectName, outerChainBaseUrl, workspaceId})
        }).catch((e) => {
          console.log(e.message)
        })
      } else {
        // 重新上传过滤后无文件需要上传时，发送成功通知，更新项目状态
        if (typeof uploadResultNoticeFn === 'function') {
          uploadResultNoticeFn({
            workspaceId,
            projectId,
            projectName,
            result: true
          })
        }
      }
    },
    // 更新文件状态
    updateFiles ({files = [], active = true, projectId, projectName = '', outerChainBaseUrl = '', workspaceId = ''}) {
      const replaceFilePath = (typeof projectName === 'string' && projectName.trim())
      files.forEach(file => {
        file.projectId = projectId
        if (projectName) {
          file.projectName = projectName
        }
        if (workspaceId) {
          file.data.workspaceId = workspaceId
        }
        const filePath = file.name.split('/')
        if (replaceFilePath) {
          file.data.filePath = `${projectName}/${filePath.slice(1).join('/')}`
        }
        if (outerChainBaseUrl) {
          const uploadUrl = `${outerChainBaseUrl}?filePath=${encodeURIComponent(file.data.filePath)}`
          file.postAction = uploadUrl
          file.outerChainBaseUrl = uploadUrl
        }
        this.$refs.upload.update(file, active)
      })
      this.computedTaskList()
      this.showLayer = true
    },
    // 删除文件
    removeFiles ({files}) {
      files.forEach(file => this.$refs.upload.remove(file))
    },
    // 上传插件 上传任务 状态改变时
    inputFile ({newFile, oldFile}) {
      try {
        const {
          isDataModule = false,
          showConfirm = false,
          uploadResultAction = '',
          callbackParams = {},
          needRecord = false,
          isDrag = false,
          upload,
          moduleName = '',
          projectName = '',
          afterSelectFn = null,
          outerChainBaseUrl = '',
          singleFileNoticeFn = null,
          uploadResultNoticeFn = null,
          againUpload = false
        } = this
        const {maximum, maximumValidateMessage, directory = false, nowPage = '', fileSize, fileSizeValidateMessage} = upload
        // 新增上传文件
        if (newFile && !oldFile) {
          const additional = {
            moduleName, // 归属类型模块名称
            isDataModule, // 当前这个文件是空间文件、数据文件
            showConfirm, // 是否需要显示确认弹窗
            needRecord, // 是否需要记录上传操作记录
            uploadResultAction, // 接口地址，获取上传结果
            nowPage, // 当前上传操作所在位置，例如： 项目库 员工库 共享库 清单数据...等等
            isDrag, // 是否拖拽上传
            isAdd: true, // 当前这个文件是否是新增的文件
            directory, // 当前这个操作是否是上传文件夹
            callbackParams, // 添加文件上传完成回调参数
            afterSelectFn, // 文件选择后，触发事件
            outerChainBaseUrl,
            msg: {},
            locationUrl: window.location.href,
            againUpload, // 是否是重新上传
            projectName,
            updateAt: Date.now(),
            singleFileNoticeFn, // 单文件成功通知地址
            uploadResultNoticeFn // 批量结果通知地址
          }
          // 外链上传地址
          if (outerChainBaseUrl) {
            additional.postAction = outerChainBaseUrl
          }
          Object.assign(newFile, additional)
          const {name, file = {}, data} = newFile
          const fullPath = file.fullPath
          if (name.includes('/') || (file && fullPath && fullPath.includes('/'))) {
            let nameData = name.includes('/') ? name.split('/') : fullPath.split('/')
            data.fileName = nameData[nameData.length - 1]
            nameData.splice(nameData.length - 1)
            const filePath = data.filePath || ''
            data.filePath = `${filePath}${filePath && filePath !== '/' ? '/' : ''}${nameData.join('/')}`.replace(/\/{2}/g, '/')
          } else {
            data.fileName = name
          }
          // 外链上传时，filePath为文件全路径（路径+文件名）
          if (newFile.outerChainBaseUrl || againUpload) {
            let parameterFilePath = this.upload.parameter.filePath
            data.filePath = `${(parameterFilePath || '/')}${newFile.name}`
            newFile.fullPath = `${(parameterFilePath || '/')}${newFile.name}`
          }
          Object.assign(newFile.data, {
            fileName: encodeURIComponent(data.fileName),
            filePath: encodeURIComponent(data.filePath),
            optType: 0,
            sourceType: 0
          })
          this.batchFileList.push(newFile)
          clearTimeout(this.batchTimer)
          // 批量文件数校验，一次最多可以上传n个文件
          if (maximum && this.batchFileList.length > maximum) {
            clearTimeout(this.uploadAlertTimer)
            this.uploadAlertTimer = setTimeout(() => {
              this.clearBatch(true)
              delete this.batchFilesBox[newFile.timeId]
              this.$message.warning(maximumValidateMessage)
            }, 300)
            return
          }
          // 文件大小验证
          if (newFile.size > fileSize) {
            clearTimeout(this.uploadAlertTimer)
            this.uploadAlertTimer = setTimeout(() => {
              this.clearBatch(true)
              delete this.batchFilesBox[newFile.timeId]
              this.$message.warning(fileSizeValidateMessage)
            }, 300)
            return
          }
          const {workspaceId} = this.upload.parameter
          this.batchTimer = setTimeout(async () => {
            // 重新上传时，验证容量前移除重名文件
            if (againUpload) {
              // 检测选择的文件夹是否与项目名称一致，若不一致弹窗询问
              if (typeof newFile.afterSelectFn === 'function') {
                // 批量选择完成后触发afterSelectFn监听
                newFile.afterSelectFn(this.batchFileList)
              }
              this.clearBatch()
            } else {
              // 空间文件，校验剩余可用容量
              if (workspaceId && !isDataModule) {
                let filesSizeTotal = 0
                this.batchFileList.forEach((fileItem) => {
                  filesSizeTotal += fileItem.size
                })
                this.checkCapacity(filesSizeTotal).then(res => {
                  this.batchFileList.forEach(fileItem => {
                    fileItem.data.uploadKey = res
                    // 选择后回调
                    if (typeof newFile.afterSelectFn === 'function') {
                      // 批量选择完成后触发afterSelectFn监听
                      newFile.afterSelectFn(this.batchFileList)
                    } else {
                      this.showUploadWaitTips(fileItem)
                    }
                  })
                  this.clearBatch()
                }).catch(() => {
                  this.clearBatch(true)
                })
              } else {
                if (newFile.isDataModule) {
                  if (newFile.showConfirm) {
                    newFile.importType = await this.importConfirm(importInventory)
                  }
                }
                this.batchFileList.forEach(this.showUploadWaitTips)
                this.clearBatch()
              }
            }
          }, 300)
        }
        // 上传文件 状态改变时
        if (newFile && oldFile) {
          // newFile.updateAt = Date.now()
          newFile.isAdd = false
          // 开始上传
          if (newFile.active !== oldFile.active) {
            // console.log('Start upload', newFile.active, newFile)
            // // 限定最小字节
            // if (newFile.size >= 0 && newFile.size < 100 * 1024) {
            //     newFile = this.$refs.upload.update(newFile, {error: 'size'})
            // }
          }
          // 上传进度
          if (newFile.progress !== oldFile.progress) {
            // console.log('progress', newFile.progress, oldFile.progress)
            this.setUploadFileStatus({
              item: newFile,
              progress: newFile.progress
            })
          }
          // 上传错误
          if (newFile.error !== oldFile.error) {
            // console.log('error', newFile.error, newFile)
          }
          // 上传成功
          if (newFile.success !== oldFile.success && newFile.xhr) {
            // debugger
            // console.log('success', newFile.success, newFile)
            let response = newFile.xhr.response || '{}'
            response = JSON.parse(response)
            if (newFile.outerChainBaseUrl) {
              // 云文档文件上传成功的状态值为0
              if (+response.code === 0) {
                const fileId = response.data.fileId
                newFile.uuid = fileId
                // 单文件成功通知
                if (typeof newFile.singleFileNoticeFn === 'function') {
                  newFile.singleFileNoticeFn({
                    workspaceId: newFile.data.workspaceId,
                    fileId,
                    result: true
                  })
                }
                this.$nextTick(() => {
                  // 外链上传，webscoket消息通知
                  this.setUploadFileStatus({
                    item: newFile,
                    uuid: response.data.fileId,
                    uploadEnd: true,
                    succeed: true
                  })
                })
              } else {
                if (typeof newFile.singleFileNoticeFn === 'function') {
                  newFile.singleFileNoticeFn({
                    workspaceId: newFile.data.workspaceId,
                    projectId: newFile.projectId,
                    projectName,
                    result: false
                  })
                }
                // 云文档文件上传错误码
                let errorMsg
                switch (+response.code) {
                  case 19014:
                    errorMsg = "文件名称不能包含特殊字符 特殊符号如： '/', '\\n','*', '\\\\', '<', '>', '|', '\\\"', ':', '?'"
                    break
                  case 19017:
                    errorMsg = '文件名称超过256个字符'
                    break
                  case 19012:
                    errorMsg = '单个文件不能超过5G，请您选择小于5G的文件上传'
                    break
                  case 19016:
                    errorMsg = '空间容量超过上限'
                    break
                  default:
                    errorMsg = uploadFailMessage
                }
                this.$message.error(errorMsg)
                // 更新文件状态，文件成功失败根据code判断
                this.$nextTick(() => {
                  // 外链上传，webscoket消息通知
                  this.setUploadFileStatus({
                    item: newFile,
                    uuid: response.id,
                    uploadEnd: true,
                    succeed: false
                  })
                })
              }
              // 遍历当前批次文件上传结果
              let complete = true
              let status = []
              const filesInfo = []
              this.batchFilesBox[newFile.timeId].forEach(item => {
                // 标记已完成
                if (item.id === newFile.id) {
                  item.fileId = newFile.uuid
                  item.msg.end = true
                  item.msg.result = (+response.code === 0)
                }
                if (!item.abort && !item.msg.end) {
                  complete = false
                }
                status.push(item.msg.result)
                filesInfo.push({
                  fileId: item.fileId,
                  status: 1,
                  suffix: item.name.substring(item.name.lastIndexOf('.') + 1),
                  path: item.data.filePath,
                  workspaceId: item.data.workspaceId
                })
              })
              if (complete) {
                // 结果回调
                if (typeof newFile.uploadResultNoticeFn === 'function') {
                  let result = !status.includes(false)
                  if (newFile.projectId && this.unmark.includes(newFile.projectId)) {
                    result = false
                    this.unmark.splice(this.unmark.indexOf(newFile.projectId), 1)
                  }
                  newFile.uploadResultNoticeFn({
                    workspaceId: newFile.data.workspaceId,
                    projectId: newFile.projectId,
                    projectName: newFile.projectName,
                    result
                  })
                }
                // 埋点请求
                this.sendUploadLog(filesInfo, {
                  nowPage,
                  directory,
                  isDrag
                })
              }
            } else {
              if (+response.code === 200) {
                newFile.uuid = response.data
                this.setUploadFileStatus({
                  item: newFile,
                  uuid: response.data
                })
                this.getUploadResult({newFile})
              }
            }
          }
        }
        // 取消上传文件
        if (!newFile && oldFile) {
          this.batchFilesBox[oldFile.timeId].forEach(item => {
            if (item.id === oldFile.id) {
              item.abort = true
            }
          })
          this.$nextTick(() => {
            this.computedTaskList()
            // 结果回调, 当取消最后一个上传中的任务时
            const currentBatch = this.batchFilesBox[oldFile.timeId]
            if (typeof oldFile.uploadResultNoticeFn === 'function' && Array.isArray(currentBatch)) {
              let completeLen = 0
              let abortLen = 0
              this.batchFilesBox[oldFile.timeId].forEach(item => {
                if (!item.abort && item.msg.end) {
                  completeLen++
                }
                if (item.abort) {
                  abortLen++
                }
              })
              if ((completeLen === currentBatch.length - 1 || abortLen === currentBatch.length) && oldFile.projectId && oldFile.projectName) {
                if (oldFile.projectId && this.unmark.includes(oldFile.projectId)) {
                  this.unmark.splice(this.unmark.indexOf(oldFile.projectId), 1)
                }
                oldFile.uploadResultNoticeFn({
                  workspaceId: oldFile.data.workspaceId,
                  projectId: oldFile.projectId,
                  projectName: oldFile.projectName,
                  result: false
                })
              }
            }
          })
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    // 为每个批次创建一个容器
    changeFiles ({newFiles, oldFiles}) {
      try {
        this.localFiles = newFiles
        // v-model中的文件数目发生变化，这里当新文件数量变大时认为是新增了一批文件
        if (newFiles.length > oldFiles.length) {
          const timeId = new Date().getTime()
          this.batchFilesBox[timeId] = newFiles.filter(item => {
            if (item.isAdd) {
              item.updateAt = Date.now()
              item.timeId = timeId
            }
            return item.isAdd
          })
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    importConfirm (params = {}) {
      const {message = '', multipleSubmit = [], key = '', width = 400, noCancelBtn = false, bodyStyle = {}, footerStyle = {}} = params
      return new Promise((resolve, reject) => {
        if (Array.isArray(multipleSubmit) && multipleSubmit.length && key) {
          this.$confirm({
            message,
            width,
            multipleSubmit,
            noCancelBtn,
            bodyStyle,
            footerStyle,
            submit: (data) => {
              resolve(data[key])
            },
            cancel: () => {
              reject(new Error('close the pop-up window'))
            }
          })
        } else {
          reject(new Error('multipleSubmit and key cannot be empty'))
        }
      })
    },
    // 上传任务开始前提示
    showUploadWaitTips (newFile) {
      const {filePath = '', workspaceId = ''} = this.upload.parameter
      newFile && this.uploadTask.unshift(newFile)
      let uploadFileNum = 0
      const uploadList = () => {
        const {parameter} = this.upload
        const {params} = parameter
        this.uploadTask.forEach(newFile => {
          // newFile.msg = {}
          if (!newFile.abort) {
            uploadFileNum++
            if (newFile.data) {
              // 设置本次上传的 额外参数 修复 上传本地清单 展开组价 组价数据未上传的bug
              if (params) {
                newFile.data.params = params
              }
            }
            // 需要记录上传操作记录时，存储下参数数据
            if (newFile.needRecord) {
              Object.assign(newFile.msg, {
                type: (this.directory ? 8 : this.uploadTask.length > 1 ? 7 : 6), // type: 文件夹 8 多个文件夹 7 单文件 6
                prjId: this.$route.params.id,
                prjName: this.prjName,
                num: this.uploadTask.length,
                spaceTo: this.nowPage,
                arr: []
              })
            }
            // 更新组件缓存数据中的冗余数据，并开始执行当条数据的上传
            !newFile.afterSelectFn && this.$refs.upload.update(newFile, true)
            this.computedTaskList()
          } else {
            this.setUploadFileStatus({item: newFile, abort: true})
          }
        })
        // 有正在上传的文件时 才显示 上传任务列表
        if (uploadFileNum) {
          this.showLayer = true
          this.$nextTick(() => {
            this.taskBarScrollTop()
            this.uploadTask = []
          })
        }
      }
      let timer
      clearTimeout(timer)
      timer = setTimeout(async () => {
        // 需判断上传文件 是否有重名文件
        const filePathList = []
        let parentPath = filePath
        if (!/\/$/.test(parentPath)) {
          parentPath += '/'
        }
        this.uploadTask.forEach((file, idx) => {
          if (!file.batchId) {
            // 解决 连续两次以上 上传文件 校验文件是否存在时 上传了 上一批次的文件名称
            this.$set(this.uploadTask[idx], 'batchId', new Date().getTime())
            // 只对当前批次的做重名校验
            let fullPath = file.name
            if (file.file.fullPath) {
              fullPath = file.file.fullPath
            }
            filePathList.push(parentPath + fullPath)
          }
        })
        if (newFile.isDataModule) {
          if (newFile.importType) {
            // 确定导入组价方案，合并导入类型参数字段
            let params = JSON.parse(this.upload.parameter.params)
            if (params instanceof Object && !isEmptyObject(params)) {
              params.ImportType = newFile.importType
            }
            this.upload.parameter.params = JSON.stringify(params)
          }
          // if (newFile.showConfirm) {
          //   try {
          //     const value = await this.importConfirm(importInventory)
          //     // 确定导入组价方案，合并导入类型参数字段
          //     let params = JSON.parse(this.upload.parameter.params)
          //     if (params instanceof Object && !isEmptyObject(params)) {
          //       params.ImportType = value
          //     }
          //     this.upload.parameter.params = JSON.stringify(params)
          //   } catch (e) {
          //     console.error(e.message)
          //   }
          // }
          uploadList()
        } else if (newFile.againUpload) {
          uploadList()
        } else {
          filePathList.length && this.checkFileExist({
            filePathList,
            sourceWorkspaceId: workspaceId
          }).then((names = []) => {
            if (names.length) {
              this.importConfirm(importDuplicateFile).then(value => {
                // 跳过重名文件时 将这个文件从任务列表删除
                const dealItem = (name) => {
                  for (let i = 0; i < this.uploadTask.length; i++) {
                    let fullPath = this.uploadTask[i].name || ''
                    if (this.uploadTask[i].file && this.uploadTask[i].file.fullPath) {
                      fullPath = this.uploadTask[i].file.fullPath
                    }
                    fullPath = this.upload.parameter.filePath + '/' + fullPath
                    if (fullPath.replace(/\/{2,}/g, '/') === name.replace(/\/{2}/g, '/')) {
                      this.uploadTask[i].data.optType = value
                      if (value === 3) {
                        this.uploadTask[i].abort = true
                      }
                    }
                  }
                }
                names.forEach(dealItem)
                uploadList()
              })
            } else {
              uploadList()
            }
          })
        }
      }, 500)
    },
    // 验证文件是否存在
    checkFileExist (params) {
      return new Promise((resolve, reject) => {
        try {
          /**/
          const { filePathList, sourceWorkspaceId } = params
          let promiseArray = []
          for (let i = 0; i < Math.ceil(filePathList.length / 100); i++) {
            const newFilePathList = filePathList.slice(i * 100, (i + 1) * 100)
            promiseArray.push(service.space.fileExist({sourceWorkspaceId, filePathList: newFilePathList}))
          }
          Promise.all(promiseArray).then(batchResult => {
            let sameNameFiles = []
            for (let i = 0; i < batchResult.length; i++) {
              const result = batchResult[i]
              if (result.code === 200 && result.data) {
                if (Array.isArray(result.data.sameNameFiles) && result.data.sameNameFiles.length) {
                  sameNameFiles.push(...result.data.sameNameFiles)
                }
              }
            }
            resolve(sameNameFiles)
          }).catch(e => reject(e))
          /**/
          // service.space.fileExist(params).then((data) => {
          //   if (+data.code === 200 && data.data) {
          //     resolve(data.data.sameNameFiles || [])
          //   } else {
          //     reject(new Error(data.message))
          //   }
          // }).catch(e => reject(e))
        } catch (e) {
          reject(e)
        }
      })
    },
    // 上传文件前校验 空间容量是否充足
    checkCapacity (filesSizeTotal) {
      return new Promise((resolve, reject) => {
        const {capacityValidateMessage: message, parameter} = this.upload
        const {workspaceId} = parameter
        // let filesSizeTotal = 0
        // this.batchFileList.forEach((fileItem) => {
        //   filesSizeTotal += fileItem.size
        // })
        service.common.checkCapacity({workspaceId, fileSize: filesSizeTotal}).then(data => {
          if (+data.code === 200) {
            if (data.data) {
              resolve(data.data)
            } else {
              if (+this.user.role === 1) {
                this.importConfirm(Object.assign(toVip, {message})).then(value => {
                  if (value === 3) {
                    this.$router.push({path: '/vip'})
                  }
                })
              } else {
                this.$message.info(message)
              }
              reject(new Error(message))
            }
          }
        })
      })
    },
    // 清楚错误后的批量文件
    clearBatch (clearLocalFiles = false) {
      clearLocalFiles && this.batchFileList.forEach(fileItem => this.$refs.upload.remove(fileItem))
      this.batchFileList = []
    },
    // 任务列表中 删除按点击
    remove (file) {
      try {
        // 记录取消上传的项目ID
        if (file.projectId && !this.unmark.includes(file.projectId)) {
          this.unmark.push(file.projectId)
        }
        if (!file.cloudFile) {
          this.$confirm({
            message: abortUploadAlertMessage,
            bodyStyle: {},
            footerStyle: {},
            submit: () => {
              // if (!(file.msg.end && file.msg.result)) {
              //   // 记录取消上传的项目ID
              //   if (file.projectId && !this.unmark.includes(file.projectId)) {
              //     this.unmark.push(file.projectId)
              //   }
              //   this.$refs.upload.remove(file)
              //   this.$nextTick(this.calcShowLayer)
              // }
              this.$refs.upload.remove(file)
              this.$nextTick(this.calcShowLayer)
            }
          })
          return
        }
        // 设置此 云文件 状态为 abort (不显示在任务列表)
        this.setUploadFileStatus({
          item: {id: file.path},
          abort: true,
          cloudFile: true
        })
        this.$nextTick(this.calcShowLayer)
      } catch (e) {
        console.error(e.message)
      }
    },
    // 关闭任务列表前 提示
    handleUploadClose () {
      try {
        const closeUploadBoxTips = getCookie('closeUploadBoxTips')
        if (!closeUploadBoxTips) {
          this.$confirm({
            message: closeUploadBoxAlertMessage,
            type: 'closeUploadBox',
            bodyStyle: {
              paddingBottom: '0px'
            },
            footerStyle: {
              border: '0px',
              paddingBottom: '24px'
            },
            submit: (data) => {
              data.checked && setCookie('closeUploadBoxTips', true)
              this.showLayer = false
              this.setUploadFileStatus({silence: true})
            }
          })
          return
        }
        this.showLayer = false
        this.setUploadFileStatus({silence: true})
      } catch (e) {
        console.error(e.message)
      }
    },
    // 获取某个文件的上传结果
    getUploadResult ({newFile, time, cloudFile}) {
      // console.log(newFile, '上传文件位置是: ' + newFile.newPage) // space、inventory、combination
      try {
        const {uuid, id, timeId, name, uploadResultAction = '', nowPage, directory, isDrag, callbackParams, data, isDataModule = false, needRecord = false, isUploadCloud = false, msg = {}, locationUrl = ''} = newFile
        // 获取上传的文件信息
        if (uuid && !isUploadCloud) {
          this[uuid] = data.filePath
        }
        time = time || 1
        let apiUrl = uploadResultAction || uploadResultUrl
        setTimeout(() => {
          axios.postArr(`${backendUrl}/${apiUrl}`, [uuid]).then(res => {
            if (+res.code === 200 && res.data) {
              for (const key in res.data) {
                let val = res.data[key] // 1: 上传中; 2: 成功; 3: 失败
                if (+val === 1) {
                  // 若当前任务 上传中 则 设置轮询获取 这个任务状态的 时间间隔为上一次时间 + 1 （优化点 防止异常任务 过多请求）
                  time = time + 1 >= 5 ? 1 : time + 1
                  this.getUploadResult({newFile, time, cloudFile})
                  return
                } else {
                  // 上传完成
                  if (!isDataModule && !cloudFile) {
                    // 检查其他是否已完成
                    let complete = true
                    const filesInfo = []
                    this.batchFilesBox[timeId].forEach(item => {
                      if (item.id === id) {
                        // 记录埋点信息
                        if (!item.fileId && item.data.workspaceId) {
                          item.status = +val === 2 ? 1 : 0
                          item.path = item.data.filePath
                          item.workspaceId = item.data.workspaceId
                        }
                        // 标记已完成
                        item.msg.end = true
                        // item.msg.result = (+val === 2)
                      }
                      if (!item.abort && !item.msg.end) {
                        complete = false
                      }
                      filesInfo.push({
                        status: item.status,
                        size: item.size,
                        suffix: item.name.substring(item.name.lastIndexOf('.') + 1),
                        path: item.path,
                        workspaceId: item.workspaceId
                      })
                    })
                    complete && this.combinationLogParams(filesInfo, {
                      nowPage,
                      directory,
                      isDrag
                    })
                  }
                  // API请求，记录上传记录
                  if (needRecord) {
                    // 检查其他是否已完成
                    let complete = true
                    // 是否存在成功上传文件
                    let hasSuccessFile = false
                    // 上传完成的文件名称
                    let successFileNames = []
                    this.batchFilesBox[timeId].map((item, index) => {
                      if (item.id === id) {
                        // 标记已完成
                        item.msg.end = true
                        // 标记成功或失败
                        item.msg.result = !!(+val === 2)
                      }
                      if (!item.abort && !item.msg.end) {
                        complete = false
                      }
                      if (!item.abort && item.msg.result) {
                        hasSuccessFile = true
                        successFileNames.push(item.name)
                      }
                    })
                    // 如果都完成并且存在上传成功的文件，发送通知信息
                    if (complete && hasSuccessFile) {
                      // 上传成功，消息通知
                      let messageParams = {
                        projectName: msg.prjName,
                        type: msg.type,
                        url: `${zjycloud}/#/project/joined/list`
                      }
                      let messageQuery = {
                        token: getCookie('ZJYTOKEN'),
                        projectId: msg.prjId,
                        workspaceId: getCookie('projectWorkspaceIdValue')
                      }
                      if (+msg.type === 6) { // 上传单文件类型
                        messageParams.tip = `上传了1个新文件: ${name}`
                      } else if (+msg.type === 7) { // 上传多个文件类型
                        Object.assign(messageParams, {
                          tip: `上传了${successFileNames.length}个新文件:"${successFileNames.join(',')}`,
                          type: successFileNames.length > 1 ? 7 : 6
                        })
                      } else if (+msg.type === 8) { // 上传文件夹
                        messageParams.tip = `上传了1个新文件夹: ${name.split('/')[0]}`
                      }
                      service.message.postMessageUpload(messageParams, messageQuery)
                    }
                  }
                }
                let succeed = false
                if (+val === 2) {
                  succeed = true
                  if (locationUrl === window.location.href) {
                    // 上传本地文件后，重新刷新空间列表
                    !isUploadCloud && Bus.$emit('SpaceFileListReload', this[uuid])
                    /**
                     * 上传成功，执行回调
                     * 执行条件：触发上传时有提供callback函数名称
                     * **/
                    if (!isEmptyObject(callbackParams) && callbackParams.fnName && this[callbackParams.fnName]) {
                      this[callbackParams.fnName](callbackParams)
                    }
                  }
                }
                this.setUploadFileStatus({
                  item: {uuid: key},
                  uploadEnd: true,
                  succeed,
                  cloudFile
                })
              }
            }
          })
        }, 1000 * time)
      } catch (e) {
        console.error(e.message)
      }
    },
    // 更新上传文件状态
    setUploadFileStatus (fileData) {
      try {
        const {item, cloudFile, progress, silence, abort, uuid, succeed, uploadEnd, clear} = fileData
        const config = {}
        let matchKey = 'id' // 以哪个字段作为 修改数据依据 默认以id
        // 设置上传进度
        progress && (config.progress = progress)
        // 设置当前文件上传状态为 中断
        abort && (config.abort = abort)
        // 设置静默上传 (已关闭任务列表，这些任务不会显示在任务列表中，但任在上传)
        silence && (config.silence = silence)
        // 设置uuid
        uuid && (config.uuid = uuid)
        // 设置 上传是否成功
        if (succeed) {
          config.succeed = succeed
          matchKey = 'uuid'
        }
        // 设置 上传是否完成
        if (uploadEnd) {
          config.uploadEnd = uploadEnd
          matchKey = 'uuid'
        }
        this._setUploadFileStatus(cloudFile ? 'cloudFiles' : 'localFiles', item, matchKey, config)
        if (clear) {
          this.cloudFiles = []
          this.localFiles = []
        }
        this.computedTaskList()
      } catch (e) {
        console.error(e.message)
      }
    },
    // 更新上传文件状态
    _setUploadFileStatus (key, item, matchKey, config) {
      try {
        if (item && item.outerChainBaseUrl) {
          Object.assign(item, config)
        } else {
          const files = this[key]
          files.forEach((current, idx) => {
            if (item) {
              if (current[matchKey] === item[matchKey]) {
                this.$set(this[key], idx, Object.assign(files[idx], config))
              }
            } else {
              // 修改所有
              this.$set(this[key], idx, Object.assign(files[idx], config))
            }
          })
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    // 开始上传云文件
    startUploadCloudFile (parameter, callbackParams) {
      try {
        this.taskBarScrollTop()
        const {uploadAction, uploadResultAction, params, pathList, uploadType, workspaceId, spaceType, showConfirm = false, isDataModule = false, nowPage = '', moduleName = '', locationUrl = ''} = parameter
        axios.post(`${backendUrl}/${uploadAction}`, {
          params,
          pathList,
          uploadType,
          workspaceId,
          spaceType
        }, {'Content-type': ContentType.formData}).then(res => {
          if (+res.code === 200) {
            const newFiles = res.data || []
            newFiles.forEach(newFile => {
              Object.assign(newFile, {
                isUploadCloud: true,
                isDataModule,
                callbackParams,
                uploadResultAction,
                showConfirm,
                nowPage,
                moduleName,
                parameter,
                locationUrl
              })
              this.setUploadFileStatus({
                item: {id: newFile.path},
                uuid: newFile.uuid,
                cloudFile: true
              })
              this.getUploadResult({newFile, cloudFile: true})
            })
          }
        })
        Bus.$emit('closeUploadCloudFile')
      } catch (e) {
        console.error(e.message)
      }
    },
    // 计算任务列表展示
    computedTaskList: _.throttle(function () {
      try {
        let files = {}
        let uploadingLength = 0 // 上传中
        let uploadedLength = 0 // 上传完成
        let uploadedStatusChangeLength = 0 // 上传完成 和 上传第二种状态 的总数
        const obj = {
          // uploadingLengthSpace: 0,
          // uploadingLengthData: 0
        }
        const computedLength = (item, key) => {
          uploadingLength++
          if (obj[key]) {
            obj[key]++
          } else {
            obj[key] = 1
          }
          // obj[`uploadingLength${capitalize(key)}`]++
          if (item.uploadEnd) {
            uploadedLength++
            uploadedStatusChangeLength++
          } else {
            if (+item.progress === 100) {
              uploadedStatusChangeLength++
            }
          }
        }
        /**
         * 计算每类类型下文件上传数量情况
         **/
        this.localFiles.concat(this.cloudFiles).forEach((item) => {
          if (!item.abort && !item.silence) {
            // 更新文件数据到files中
            if (files[item.moduleName]) {
              const {items, updateAt} = files[item.moduleName]
              // const {items, details, updateAt} = files[item.moduleName]
              // if (details[item.nowPage]) {
              //   details[item.nowPage] = [item, ...details[item.nowPage]]
              // } else {
              //   details[item.nowPage] = [item]
              // }
              files[item.moduleName] = {
                items: [item, ...items],
                // details,
                details: {},
                updateAt: Math.max(item.updateAt, updateAt)
              }
            } else {
              files[item.moduleName] = {
                items: [item],
                details: {},
                // details: item.nowPage ? {
                //   [item.nowPage]: [item]
                // } : {},
                updateAt: item.updateAt
              }
            }
            computedLength(item, item.moduleName)
          }
        })
        this.files = files
        // 按照updateAt对files进行排序
        const filesSorted = []
        for (let key in files) {
          let {items = [], updateAt = Date.now(), details = {}} = files[key]
          items = items.sort((a, b) => b.updateAt - a.updateAt)
          filesSorted.push({
            name: key,
            updateAt,
            details,
            items
          })
        }
        this.filesSorted = filesSorted.sort((a, b) => b.updateAt - a.updateAt)
        this.changeTaskOrder++
        this.uploadingLength = uploadingLength // 正在上传文件总数
        this.uploadedLength = uploadedLength // 已上传文件总数
        this.uploadedStatusChangeLength = uploadedStatusChangeLength // 上传完成 和 上传第二种状态 的总数
        // this.uploadingLengthSpace = obj.uploadingLengthSpace
        // this.uploadingLengthData = obj.uploadingLengthData
        for (let key in obj) {
          this.files[key].uploading = obj[key]
        }
        this.refreshUploadTask++
      } catch (e) {
        console.error(e.message)
      }
    }, 200),
    // 上传任务列表 滚动条滚动到最顶部
    taskBarScrollTop () {
      try {
        this.setUploadTaskStatus(true)
        const fileUploadBody = document.getElementById('fileUploadBody')
        fileUploadBody && fileUploadBody.scrollTo(0, 0)
        // this.taskOrder = this.isDataModule ? ['data', 'space'] : ['space', 'data']
        this.changeTaskOrder++
      } catch (e) {
        console.error(e.message)
      }
    },
    // 埋点数组组装
    async combinationLogParams (filesInfo, additional = {}) {
      try {
        if (!Array.isArray(filesInfo) || !filesInfo.length) {
          return
        }
        let files = []
        let length = 0
        let $status = []
        for (let i = 0; i < filesInfo.length; i++) {
          const { path, workspaceId, suffix, status, size } = filesInfo[i]
          // 上传成功，查询文件ID
          if (status === 1) {
            // 获取文件ID
            await this.getFileId({path: decodeURIComponent(path), workspaceId}).then(fileId => {
              files.push({fileId, suffix, length: size, status})
              length += size
              $status.push(status)
            })
          } else {
            // 上传失败，直接记录失败文件信息
            files.push({suffix, length: size, status})
            $status.push(status)
          }
        }
        // status: 全部成功 1， 部分成功部分失败 2， 全部失败 0
        Object.assign(additional, {
          length,
          status: $status.includes(1) ? ($status.includes(0) ? 2 : 1) : 0
        })
        this.sendUploadLog(files, additional)
      } catch (e) {
        console.log(e.message)
      }
    },
    // 埋点
    sendUploadLog (files = [], additional) {
      try {
        if ((!Array.isArray(files) || !files.length) || (typeof additional !== 'object' || isEmptyObject(additional))) {
          return
        }
        const { nowPage, directory, drag, length = 0, status } = additional
        let fnCode = null
        switch (nowPage) {
          case 'enterprise': // 项目库
            fnCode = drag ? 100112029 : directory ? 100112028 : 100112027
            break
          case 'personage': // 个人空间
            fnCode = drag ? 100113052 : directory ? 100113006 : 100113004
            break
          case 'share': // 共享空间
            fnCode = drag ? 100114019 : directory ? 100114004 : 100114003
            break
          case 'record': // 备案库
            fnCode = 100112064
          default:
        }
        fnCode && this.sentLog(fnCode, {count: files.length, files, length, status})
      } catch (e) {
        console.log(e.message())
      }
    },
    // 获取文件ID
    getFileId (query) {
      return new Promise((resolve, reject) => {
        service.space.getFileMeta(query).then(res => {
          if (res.code === 200 && res.data && !isEmptyObject(res.data)) {
            resolve(res.data.fileId)
          } else {
            reject(new Error('Failed to get file ID'))
          }
        }).catch(e => {
          reject(e.message)
        })
      })
    },
    // 计算上传弹窗是否显示
    calcShowLayer () {
      if (this.localFiles.length === 0 && this.cloudFiles.length === 0) {
        this.showLayer = false
      }
    }
  },
  watch: {
    // 上传完成的任务数量
    uploadedLength (value) {
      if (value === this.uploadingLength) {
        Bus.$emit('uploadAll')
        this.setUploadTaskStatus(false)
      }
      Bus.$emit('uploadOne')
    },
    // 上传中的任务数量
    uploadingLength () {
      if (this.uploadedLength === this.uploadingLength) {
        this.setUploadTaskStatus(false)
      }
    },
    // 上传完成 和 上传第二种状态 的总数
    uploadedStatusChangeLength (value) {
      if (value === this.uploadingLength) {
        this.setUploadTaskStatus(false)
      }
    },
    // 退出登录、session超时时 关闭任务列表框
    uploadTaskShow () {
      this.showLayer = false
      this.setUploadFileStatus({clear: true})
    }
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
